import { getDefaultStoreUrl } from "../../../modules/regionalStore";

const withProductLink = defaultStoreUrl => item =>
  item.variantId
    ? { ...item, productUrl: `${defaultStoreUrl}prd/${item.variantId}` }
    : item;

export default function bagWithProductLinks(bag, getState) {
  const state = getState();
  const defaultStoreUrl = getDefaultStoreUrl(state);
  return {
    ...bag,
    items: bag.items.map(withProductLink(defaultStoreUrl))
  };
}



// WEBPACK FOOTER //
// ./template/state/middleware/bag/helpers/bagWithProductLinks.js